import styled from 'styled-components'

export default styled.option`
  &:disabled {
    color: #ccc;
  }
`
